export default __webpack_public_path__ + "static/media/tete17.396a336d.png";